import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 28, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const Overline = ({ children }) => (
  <p className="text-xs tracking-[0.25em] uppercase font-medium text-rust">
    {children}
  </p>
);

export const SectionHeading = ({ overline, title, className = "" }) => (
  <Reveal className={className}>
    <Overline>{overline}</Overline>
    <h2 className="mt-4 font-display uppercase text-3xl sm:text-4xl lg:text-5xl font-normal tracking-wide leading-tight text-cream">
      {title}
    </h2>
  </Reveal>
);
